import type { ButtonProps } from "@mantine/core";
import { Button } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useCommonColors } from "octalog-base";

interface RemoveButtonProps extends Omit<ButtonProps, "color" | "variant"> {
  onClick: () => void;
}

export function RemoveButton({ onClick, ...rest }: RemoveButtonProps) {
  const commonColors = useCommonColors();
  return (
    <Button color={commonColors.redPrimary} onClick={onClick} variant="transparent" {...rest}>
      <IconX color={commonColors.redPrimary} size={16} />
    </Button>
  );
}
